import React from 'react'
import { Outlet } from 'react-router-dom'

import SideBar from '@src/components/sideBar/SideBar'
import Header from '@src/components/headers/Header'
import { Footer } from '@src/components/footer/Footer'
import AuthChecker from '@src/components/common/AuthChecker'
import AppLayout from '../AppLayout'

const MainLayout = () => {
	return (
		<>
			<AppLayout>
				<AppLayout.Header>
					<Header />
				</AppLayout.Header>
				<AppLayout.Main>
					<SideBar />
					<AppLayout.MainContent>
						<AppLayout.OutletWrapper>
							<Outlet />
						</AppLayout.OutletWrapper>
						<Footer />
						{/* <AppLayout.Footer>
							<div>aaa</div>
						</AppLayout.Footer> */}
					</AppLayout.MainContent>
				</AppLayout.Main>
			</AppLayout>
			<AuthChecker />
		</>
	)
}

export default MainLayout
